import {
    MeshStandardMaterial,
    // CanvasTexture,
    PlaneGeometry,
    CircleGeometry,
    // MeshPhysicalMaterial,
    // Color,
} from "three";
import { Reflector } from "three/addons/objects/Reflector.js";
import { getMeshParams } from "helpers";

// const simpleNormalMap = (width, height) => {
//     const canvas = document.createElement("canvas");
//     canvas.width = width;
//     canvas.height = height;

//     const ctx = canvas.getContext("2d");

//     ctx.fillStyle = "rgb(128, 127, 255)";
//     ctx.fillRect(0, 0, canvas.width, canvas.height);

//     const normalMap = new CanvasTexture(canvas);

//     return normalMap;
// };

export const getMaterial = (type, color = "#ffffff", opacity = 1) => {
    // if (type === "metal")
    //     return new MeshPhysicalMaterial({
    //         clearcoat: 1,
    //         roughness: 0.2,
    //         clearcoatRoughness: 0.1,
    //         metalness: 1,
    //         sheen: 0.4,
    //         sheenColor: new Color(color),
    //         // emissiveIntensity: 1,
    //         // sheenRoughness: 0.5,
    //         // emissive: "rgb(60, 60, 60)",
    //         opacity: 1,
    //         transparent: false,
    //         transmission: 0,
    //         map: null,
    //         normalMap: simpleNormalMap(500, 500),
    //     });
    const materialType = {
        metal: {
            metalness: 1,
            roughness: 0.1,
            // emissive: new Color(color),
            // emissive: color,
            // emissiveIntensity: 0.15,
            // normalMap: simpleNormalMap(500, 500),
        },

        wood: {
            roughness: 0.5,
            // emissive: new Color(color),
            // emissive: color,
            // emissiveIntensity: 0.15,
        },

        wall: {
            roughness: 1,
        },
        glass: {
            opacity,
            transparent: true,
        },

        frostedGlass: {
            roughness: 0.2,
            transparent: true,
            opacity: 0.8,
        },
        ceramic: {
            metalness: 0.2,
            roughness: 0.8,
        },
        marble: {
            metalness: 0.1,
            roughness: 0.2,
        },

        plastic: {
            roughness: 0.6,
        },
    };

    const material = new MeshStandardMaterial({
        // color: new Color(color),
        color,
        ...materialType[type],
    });
    return material;
};

export const getMirrors = (meshes, type) => {
    const mirrors = [];
    meshes.forEach((mesh) => {
        const { rotate, position, width, height } = getMeshParams(mesh, 0.01);
        let plane;
        if (type === "plane") plane = new PlaneGeometry(width, height);
        else plane = new CircleGeometry(width / 2);

        const mirror = new Reflector(plane, {
            clipBias: 0.003,
            textureWidth: 1024,
            textureHeight: 1024,
            color: 0xb5b5b5,
        });

        mirror.position.set(position[0], -position[2], position[1]);
        if (type === "plane") mirror.rotation.set(rotate[1], rotate[0], rotate[2]);
        else mirror.rotation.set(0, Math.PI, 0);
        mirrors.push(mirror);
    });

    return mirrors;
};
